// routes.js
import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Layout from './components/Layout'

import HomePage from './pages/Home'
import Servicios from './pages/Servicios'
import ServicioAutenticidadContenido from './pages/ServicioAutenticidadContenido'
import ServicioCryptoAgilidad from './pages/ServicioCryptoAgilidad'
import SobreNosotros from './pages/SobreNosotros'
import Contacto from './pages/Contacto'
import AvisoLegal from './pages/AvisoLegal'
import SiteMap from './pages/SiteMap'
import PoliticaPrivacidad from './pages/PoliticaPrivacidad'
import CanalResponsable from './pages/CanalResponsable';
import Talento from './pages/TrabajaConNosotros'

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route
            path="/servicios/autenticidad-contenido-digital"
            element={<ServicioAutenticidadContenido />}
          />
          <Route
            path="/servicios/crypto-agilidad-cbom"
            element={<ServicioCryptoAgilidad />}
          />
          <Route path="/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/talento" element={<Talento />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/site-map" element={<SiteMap />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/canal-responsable" element={<CanalResponsable />} />

          {/* English routes — legal pages intentionally have no /en variant */}
          <Route path="/en" element={<HomePage />} />
          <Route path="/en/servicios" element={<Servicios />} />
          <Route
            path="/en/servicios/autenticidad-contenido-digital"
            element={<ServicioAutenticidadContenido />}
          />
          <Route
            path="/en/servicios/crypto-agilidad-cbom"
            element={<ServicioCryptoAgilidad />}
          />
          <Route path="/en/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/en/contacto" element={<Contacto />} />
          <Route path="/en/talento" element={<Talento />} />
          <Route path="/en/site-map" element={<SiteMap />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default AppRoutes
